module.exports = __webpack_public_path__ + "img/login-bg-v2.f091a79d.jpg";